import { BaseError } from '@adv-frontend/error';
import { IsNever } from '@direct-frontend/stdlib';

export function createPromiseWithResolvers<T = never>(): {
    promise: Promise<T>;
    resolve: IsNever<T, () => void, (value: T | PromiseLike<T>) => void>;
    reject: (reason?: unknown) => void;
} {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- тип описан во внешнем интерфейсе функции
    let returnResolve: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- тип описан во внешнем интерфейсе функции
    let returnReject: any;

    const promise = new Promise<T>((resolve, reject) => {
        returnResolve = resolve;
        returnReject = reject;
    });

    return { promise, resolve: returnResolve, reject: returnReject };
}

export function wait(timeout: number) {
    return new Promise(resolve => {
        setTimeout(resolve, timeout);
    });
}

/**
 * Функция для упрощения оповещения об ошибке.
 * В продакшене ошибка логируется, в остальных окружениях выбрасывается ошибка.
 */
export function reportError(error: BaseError) {
    if (process.env.NODE_ENV === 'production') {
        console.error(error);
    } else {
        throw error;
    }
}
